// @flow

"use strict";

import Constants from "./constants/constants";
import Logger from "./model/common/logger";
import Device from "./model/common/device";
import Environment from "./model/common/environment";
import Placement from "./model/common/placement";
import PlacementSetting from "./model/common/placement-setting";
import User from "./model/common/user";
import UzouGlobal from "./model/outer/uzou-global";
import Monitoring from "./model/outer/monitoring";
import OuterDIContainer from "./model/outer/outer-di-container";
import OuterWidgetHandler from "./handler/outer-widget-handler";
import CookieUtil from "./util/cookie-util";


(function(window: Window, document: HTMLDocument){
  // 外部設定ファイル(./setting/${placement_code}/setting.jsonから値を取得)
  // ここのバインドに失敗した場合は配信サーバへのリクエストが発生しない
  const placementSetting: PlacementSetting = PlacementSetting.create({"placement_code":"okwave_pc","placement_id":619,"header_text":"こちらの記事もオススメ","published_at_fmt":"","environment":"production","sentryDSN":"https://192ad2356e5d4330aceef03e56efe0a5@sentry.io/103759"});

  const placement: Placement = Placement.create(placementSetting.placementId, placementSetting.placementCode);

  const environment = Environment.create(placementSetting.environment);

  // 初回のみloggerを生成
  const logger = window.Uzou && window.Uzou.logger ? window.Uzou.logger : Logger.getInstance(environment, placementSetting, window);

  try {
    const device: Device = Device.create(window); // 端末情報作成

    const user: User = User.create(CookieUtil.loadUUID(document));  // ユーザ情報

    // DIコンテナを生成
    let diContainer: OuterDIContainer = OuterDIContainer.getInstance();

    // ここのコメントは削除しないでください
    // diContainer = ${__placement_outer_frame_di__}.getInstance();を
    // diContainer = require("./placement/${placement.code}/${placement.code}-outer-frame.js").getInstance();で置換する
    diContainer = require("./placement/okwave_pc/okwave_pc-outer-frame.js").getInstance();

    // 初回のみ生成
    let uzouGlobal = function(): UzouGlobal{
      if(window.Uzou) {
        return window.Uzou;
      }
      const monitoring: Monitoring = Monitoring.getInstance(diContainer, environment, window, document);

      const uzouGlobal: UzouGlobal = UzouGlobal.getInstance(monitoring, logger, window);

      window.Uzou = uzouGlobal;

      return uzouGlobal;
    }();

    // ウィジェット表示開始
    OuterWidgetHandler.appendIframeElement(uzouGlobal, placement, environment, device, user, diContainer, window, document);
  } catch (e) {
    logger.error(e);
  }
  // TODO 後々ログ送信が出来るようになったらタグ発火ログを送りたい
  // finally {
  //
  // }

})(window, document);



// WEBPACK FOOTER //
// ./src/js/outer-frame.js